export const bounceY = {
  animate: {
    y: [0, 10, 0],
    transition: { repeat: Infinity, duration: 1.5, ease: "easeInOut" },
  },
};
